import React, { Component } from "react";
import { message, Row, Col, Divider, Select, PageHeader, Spin, Table } from "antd";
import { ArrowLeftOutlined, EditOutlined, SwapRightOutlined, DeleteOutlined, PlusOutlined, ClockCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Tag } from "antd";
import { Form, FormItem, ButtonItem, ErrorItem, InputItem, TextAreaItem, InputNumberItem, SelectInsumosItem, SelectItem, DatePickerItem, round2Decimals, MensajeError } from "../../../../Components/Items";
import SelectProyectosItem from "../../../../Components/SelectProyectosItem";
import BotonAyudaManuales from "../../../../Components/BotonAyudaManuales";
import InfoCard from "../../../../Components/InfoCard";
import { renderCampoOrdenProduccionPU, SELECTORES_REFERENCIA } from "../../../../Components/CampoDinamicoOrdenProduccionPU";
import { flattenCampos, formatearValorCampoOrden, valoresParaFormulario } from "../ConfiguracionOrdenesDeProduccionPU/camposOrdenProduccion.utils";
import { formatearTiempo, formatearTiempoCiclo, formatearFechaHora } from "../OrdenesDeProduccionPU/PlaneacionProduccionPU/planeacion.utils";
import ModalAjustarInicioRealPU from "../OrdenesDeProduccionPU/PlaneacionProduccionPU/ModalAjustarInicioRealPU";

const { Option } = Select;

class OrdenDeProduccionPU extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    saving: false,
    secciones: [],
    orden: null,
    soloLectura: false,
    presupuesto: null,
    partidaSnapshot: null,
    flujo: null,
    etapasFlujo: [],
    matrices: [],
    cantidadEsperada: null,
    horario: null,
    modalAjusteInicio: false,
  };

  timeoutHorario = null;

  componentWillUnmount() {
    clearTimeout(this.timeoutHorario);
  }

  programarValidacionHorario = () => {
    clearTimeout(this.timeoutHorario);
    this.timeoutHorario = setTimeout(this.validarHorario, 400);
  };

  validarHorario = () => {
    const fechaInicio = this.formRef.current?.getFieldValue("fechaInicio");
    if (!fechaInicio || (!this.presupuestoPUId && !this.matrizId && !this.ordenId)) return;
    const body = { empresaId: this.props.empresaId, fechaInicio };
    if (this.ordenId) {
      body.ordenId = this.ordenId;
    } else {
      body.cantidadEsperada = this.formRef.current?.getFieldValue("cantidadEsperada");
      if (!(body.cantidadEsperada > 0)) return;
      if (this.matrizId) {
        body.matrizId = this.matrizId;
      } else {
        body.presupuestoPUId = this.presupuestoPUId;
        body.partidaPath = this.partidaPath;
        body.piezaId = this.piezaId;
      }
    }
    axios
      .post("ordenesDeProduccionPU/validarHorarioOrden", body, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ horario: res.data });
      })
      .catch(() => {});
  };

  usarHoraSugerida = () => {
    const sugerencia = this.state.horario?.sugerencia;
    if (!sugerencia) return;
    this.formRef.current?.setFieldsValue({ fechaInicio: moment(sugerencia) });
    this.validarHorario();
  };

  manejarHorarioOcupado = (data) => {
    this.setState((prev) => ({ horario: { ...(prev.horario || {}), libre: false, ordenChoque: data.ordenChoque, sugerencia: data.sugerencia } }));
    MensajeError({ message: data.error });
  };

  get ordenId() {
    return this.props.location?.state?.ordenId;
  }

  get presupuestoPUId() {
    return this.props.location?.state?.presupuestoPUId || this.state.orden?.presupuestoPUId?._id;
  }

  get matrizId() {
    return this.props.location?.state?.matrizId;
  }

  get partidaPath() {
    return this.props.location?.state?.partidaPath || [];
  }

  get piezaId() {
    return this.props.location?.state?.piezaId;
  }

  get proyectoGeneralIdPresupuesto() {
    return this.props.location?.state?.proyectoGeneralId;
  }

  get proyectoProduccionIdPresupuesto() {
    return this.props.location?.state?.proyectoProduccionId;
  }

  componentDidMount() {
    this.setState({ soloLectura: !!this.props.location?.state?.soloLectura });
    this.cargarConfiguracion().then(() => {
      if (this.ordenId) {
        this.cargarOrden();
      } else {
        this.cargarDatosPartida();
      }
    });
  }

  cargarConfiguracion = () => {
    return axios
      .post("configuracionCamposOrdenProduccionPU/obtenerConfiguracion", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) this.setState({ secciones: res.data.configuracion.secciones || [] });
      })
      .catch(() => MensajeError({ message: "Error al cargar la configuración de campos" }));
  };

  cargarDatosPartida = () => {
    if (!this.matrizId && (!this.presupuestoPUId || this.partidaPath.length === 0)) return;
    this.setState({ loading: true });
    const origen = this.matrizId
      ? { matrizId: this.matrizId, cantidadEsperada: 1 }
      : { presupuestoPUId: this.presupuestoPUId, partidaPath: this.partidaPath, piezaId: this.piezaId };
    axios
      .post("ordenesDeProduccionPU/datosPartidaParaOrden", { empresaId: this.props.empresaId, ...origen }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            presupuesto: res.data.presupuesto,
            partidaSnapshot: res.data.partidaSnapshot,
            flujo: res.data.flujo,
            etapasFlujo: res.data.etapas || [],
            matrices: res.data.matrices || [],
            cantidadEsperada: res.data.partidaSnapshot?.cantidadTotal || 1,
          });
          this.formRef.current?.setFieldsValue({
            cantidadEsperada: res.data.partidaSnapshot?.cantidadTotal || 1,
            proyectoOrigenId: this.proyectoGeneralIdPresupuesto,
            proyectoEjecucionId: this.proyectoProduccionIdPresupuesto,
          });
          this.validarHorario();
        } else {
          MensajeError({ message: res.data.error || "No se pudo cargar la partida" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  cargarOrden = () => {
    this.setState({ loading: true });
    axios
      .post("ordenesDeProduccionPU/verOrden", { ordenId: this.ordenId, empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2 && res.data.orden) {
          const orden = res.data.orden;
          this.formRef.current?.setFieldsValue({
            ...valoresParaFormulario(this.state.secciones, orden.valores),
            codigoProduccion: orden.codigoProduccion,
            descripcion: orden.descripcion,
            insumoRelacionadoId: orden.insumoRelacionadoId?._id,
            fechaInicio: moment(orden.fechaInicio || orden.createdAt),
          });
          this.setState({
            orden,
            flujo: orden.flujoId,
            etapasFlujo: res.data.etapas || [],
            horario: {
              libre: true,
              duracionEstimadaMin: orden.duracionEstimadaMin,
              fechaFinEstimada: orden.fechaFinEstimada,
            },
            matrices: (orden.matrices || []).map((m) => ({
              matrizId: m.matrizId?._id || m.matrizId,
              clave: m.matrizId?.clave || m.clave,
              descripcion: m.matrizId?.descripcion || m.descripcion,
              unidad: m.unidad,
              cantidadRequerida: m.cantidadRequerida,
              tiempoCiclo: m.tiempoCiclo,
              tiempoCicloPorEtapa: m.tiempoCicloPorEtapa,
              especificaciones: m.especificaciones,
            })),
          });
        } else {
          MensajeError({ message: "No se pudo cargar la orden" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  factorEscala = () => {
    const base = this.state.partidaSnapshot?.cantidadTotal || 1;
    const cantidadEsperada = this.state.cantidadEsperada || base;
    return base > 0 ? cantidadEsperada / base : 1;
  };

  requeridoDe = (matriz) => (this.ordenId ? matriz.cantidadRequerida || 0 : round2Decimals((matriz.cantidadRequerida || 0) * this.factorEscala()));

  habilitarEdicion = () => this.setState({ soloLectura: false });

  onFinishFailed = (e) => ErrorItem(e);

  onFinish = (values) => (this.ordenId ? this.guardarEdicion(values) : this.crearOrden(values));

  crearOrden = (values) => {
    if (this.state.matrices.length === 0) {
      MensajeError({ message: "Esta orden no tiene matrices para producir" });
      return;
    }

    const { cantidadEsperada, fechaInicio, proyectoEjecucionId, proyectoOrigenId, codigoProduccion, descripcion, insumoRelacionadoId, tipoLista, ...valores } = values;

    this.setState({ saving: true });
    axios
      .post(
        "ordenesDeProduccionPU/agregarOrden",
        {
          empresaId: this.props.empresaId,
          usuarioId: this.props.usuarioId,
          ...(this.matrizId
            ? { matrizId: this.matrizId }
            : { presupuestoPUId: this.presupuestoPUId, partidaPath: this.partidaPath, piezaId: this.piezaId }),
          cantidadEsperada,
          fechaInicio,
          proyectoEjecucionId,
          proyectoOrigenId,
          codigoProduccion,
          descripcion,
          insumoRelacionadoId,
          tipoLista,
          valores,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ saving: false });
        if (res.data.success === 2) {
          message.success(`Orden de producción ${res.data.orden.folio} creada correctamente`);
          if (res.data.advertencia) message.warning(res.data.advertencia, 6);
          this.props.history.push("/panel/ordenesDeProduccion");
        } else if (res.data.horarioOcupado) {
          this.manejarHorarioOcupado(res.data);
        } else {
          MensajeError({ message: res.data.error || "No se pudo crear la orden" });
        }
      })
      .catch(() => {
        this.setState({ saving: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  guardarEdicion = (values) => {
    const { codigoProduccion, descripcion, insumoRelacionadoId, fechaInicio, ...valores } = values;
    const body = {
      ordenId: this.ordenId,
      empresaId: this.props.empresaId,
      valores,
      codigoProduccion,
      descripcion,
      insumoRelacionadoId,
      fechaInicio,
    };

    this.setState({ saving: true });
    axios
      .post("ordenesDeProduccionPU/editarOrden", body, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ saving: false });
        if (res.data.success === 2) {
          message.success("Orden actualizada correctamente");
          this.setState({ soloLectura: true }, () => this.cargarOrden());
        } else if (res.data.horarioOcupado) {
          this.manejarHorarioOcupado(res.data);
        } else {
          MensajeError({ message: res.data.error || "No se pudo actualizar la orden" });
        }
      })
      .catch(() => {
        this.setState({ saving: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  cambiarEspecificacion = (matrizIndex, espIndex, cambios) => {
    this.setState((prev) => ({
      matrices: prev.matrices.map((m, i) =>
        i !== matrizIndex ? m : { ...m, especificaciones: m.especificaciones.map((e, j) => (j === espIndex ? { ...e, ...cambios } : e)) }
      ),
    }));
  };

  agregarEspecificacion = (matrizIndex) => {
    this.setState((prev) => ({
      matrices: prev.matrices.map((m, i) =>
        i !== matrizIndex ? m : { ...m, especificaciones: [...(m.especificaciones || []), { insumoId: null, cantidad: null, observaciones: "" }] }
      ),
    }));
  };

  eliminarEspecificacion = (matrizIndex, espIndex) => {
    this.setState((prev) => ({
      matrices: prev.matrices.map((m, i) =>
        i !== matrizIndex ? m : { ...m, especificaciones: m.especificaciones.filter((_, j) => j !== espIndex) }
      ),
    }));
  };

  guardarBom = () => {
    const especificacionesPorMatriz = this.state.matrices.map((m) => ({
      matrizId: m.matrizId,
      especificaciones: (m.especificaciones || [])
        .filter((e) => e.insumoId)
        .map((e) => ({ insumoId: e.insumoId?._id || e.insumoId, cantidad: e.cantidad, observaciones: e.observaciones })),
    }));

    if (especificacionesPorMatriz.some((m) => m.especificaciones.some((e) => !e.cantidad || e.cantidad <= 0))) {
      MensajeError({ message: "Cada insumo del BOM necesita cantidad mayor a 0" });
      return;
    }

    this.setState({ saving: true });
    axios
      .post(
        "ordenesDeProduccionPU/editarOrden",
        { ordenId: this.ordenId, empresaId: this.props.empresaId, especificacionesPorMatriz },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ saving: false });
        if (res.data.success === 2) {
          message.success("BOM actualizado correctamente");
          this.cargarOrden();
        } else {
          MensajeError({ message: res.data.error || "No se pudo actualizar el BOM" });
        }
      })
      .catch(() => {
        this.setState({ saving: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  renderEspecificacionesEditables() {
    const { matrices, soloLectura } = this.state;
    return (
      <>
        {matrices.map((matriz, matrizIndex) => (
          <div key={matriz.matrizId} style={{ marginBottom: 16 }}>
            <div style={{ fontWeight: 600, marginBottom: 6 }}>{this.etiquetaMatriz(matriz)}</div>
            <Table
              size="small"
              pagination={false}
              rowKey={(_, i) => i}
              dataSource={matriz.especificaciones || []}
              locale={{ emptyText: "Sin insumos" }}
              columns={[
                {
                  title: "Insumo",
                  key: "insumo",
                  render: (_, esp, espIndex) =>
                    soloLectura ? (
                      `${esp.insumoId?.clave ? esp.insumoId.clave + " - " : ""}${esp.insumoId?.descripcion || "—"}`
                    ) : (
                      <SelectInsumosItem
                        tiposInsumos="inventariables"
                        empresaId={this.props.empresaId}
                        headersToken={this.props.headersToken}
                        insumoPreCargado={esp.insumoId?._id ? esp.insumoId : undefined}
                        value={esp.insumoId?._id || esp.insumoId}
                        onChange={(insumoId, insumo) => this.cambiarEspecificacion(matrizIndex, espIndex, { insumoId: insumo || insumoId })}
                      />
                    ),
                },
                {
                  title: "Cantidad por pieza",
                  key: "cantidad",
                  width: 140,
                  render: (_, esp, espIndex) =>
                    soloLectura ? (
                      esp.cantidad
                    ) : (
                      <InputNumberItem
                        style={{ width: "100%" }}
                        min={0.0001}
                        value={esp.cantidad}
                        onChange={(cantidad) => this.cambiarEspecificacion(matrizIndex, espIndex, { cantidad })}
                      />
                    ),
                },
                {
                  title: "Observaciones",
                  key: "observaciones",
                  render: (_, esp, espIndex) =>
                    soloLectura ? (
                      esp.observaciones || "—"
                    ) : (
                      <InputItem
                        value={esp.observaciones}
                        onChange={(e) => this.cambiarEspecificacion(matrizIndex, espIndex, { observaciones: e.target.value })}
                      />
                    ),
                },
                ...(soloLectura
                  ? []
                  : [
                      {
                        title: "",
                        key: "acciones",
                        width: 60,
                        render: (_, esp, espIndex) => (
                          <ButtonItem
                            type="default"
                            rojo
                            size="small"
                            icon={<DeleteOutlined />}
                            onClick={() => this.eliminarEspecificacion(matrizIndex, espIndex)}
                          />
                        ),
                      },
                    ]),
              ]}
            />
            {!soloLectura && (
              <ButtonItem size="small" icon={<PlusOutlined />} style={{ marginTop: 6 }} onClick={() => this.agregarEspecificacion(matrizIndex)}>
                Agregar insumo
              </ButtonItem>
            )}
          </div>
        ))}
        {!soloLectura && (
          <ButtonItem type="primary" loading={this.state.saving} onClick={this.guardarBom}>
            Guardar BOM
          </ButtonItem>
        )}
      </>
    );
  }

  renderTablaMatrices() {
    return (
      <Table
        size="small"
        tableLayout="fixed"
        pagination={false}
        rowKey="matrizId"
        dataSource={this.state.matrices}
        locale={{ emptyText: "Sin matrices" }}
        columns={[
          { title: "Clave", dataIndex: "clave", key: "clave", width: 100 },
          { title: "Descripción", dataIndex: "descripcion", key: "descripcion", ellipsis: true },
          { title: "Unidad", dataIndex: "unidad", key: "unidad", width: 100 },
          {
            title: "Requerido",
            key: "requerido",
            width: 110,
            align: "right",
            render: (_, matriz) => this.requeridoDe(matriz),
          },
          {
            title: "Tiempo ciclo por etapa (por pieza)",
            key: "tiempoCiclo",
            render: (_, matriz) => {
              const nombreEtapa = new Map((this.state.etapasFlujo || []).map((e) => [e._id, e.nombre]));
              const tiempos = matriz.tiempoCicloPorEtapa || [];
              if (tiempos.length === 0) return <span style={{ color: "#bfbfbf" }}>Sin tiempo</span>;
              return tiempos.map((t) => (
                <Tag key={t.etapaId}>
                  {nombreEtapa.get(t.etapaId?.toString()) || "Etapa"}: {formatearTiempoCiclo(t.minutos, this.props.unidadTiempoProduccion)}
                </Tag>
              ));
            },
          },
          {
            title: "Tiempo estimado",
            key: "tiempoEstimado",
            width: 130,
            align: "right",
            render: (_, matriz) =>
              formatearTiempo(
                (matriz.tiempoCicloPorEtapa || []).reduce((acc, t) => acc + (t.minutos || 0), 0) * this.requeridoDe(matriz),
                this.props.unidadTiempoProduccion
              ),
          },
        ]}
      />
    );
  }

  renderPlaneacion() {
    const { horario } = this.state;
    if (!horario) return null;
    const sinTiempo = horario.matricesSinTiempo || [];
    const ocupado = horario.libre === false && horario.ordenChoque;
    const acento = ocupado ? "#fa8c16" : "#00BFD6";

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          flexWrap: "wrap",
          backgroundColor: ocupado ? "#fff7e6" : "white",
          borderRadius: 12,
          borderLeft: `4px solid ${acento}`,
          padding: "10px 20px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
          marginBottom: 10,
        }}
      >
        <ClockCircleOutlined style={{ fontSize: 18, color: acento }} />
        <div style={{ flex: 1, minWidth: 260 }}>
          {ocupado ? (
            <>
              <div style={{ fontWeight: 600, color: "#1a3a4a" }}>
                Ese horario ya lo ocupa la orden {horario.ordenChoque.folio}
              </div>
              <div style={{ fontSize: 12, color: "#595959" }}>
                {formatearFechaHora(horario.ordenChoque.fechaInicio)} → {formatearFechaHora(horario.ordenChoque.fechaFinEstimada)}
                {horario.sugerencia && (
                  <>
                    {" · "}Primera hora libre: <b>{formatearFechaHora(horario.sugerencia)}</b>
                  </>
                )}
              </div>
            </>
          ) : (
            <div style={{ display: "flex", gap: 24, flexWrap: "wrap", color: "#1a3a4a" }}>
              <span>
                <span style={{ color: "#8c8c8c" }}>Duración estimada </span>
                <b>{formatearTiempo(horario.duracionEstimadaMin || 0, this.props.unidadTiempoProduccion)}</b>
              </span>
              <span>
                <span style={{ color: "#8c8c8c" }}>Termina aprox. </span>
                <b>{formatearFechaHora(horario.fechaFinEstimada)}</b>
              </span>
            </div>
          )}
          {sinTiempo.length > 0 && (
            <div style={{ fontSize: 12, color: "#ad6800", marginTop: 2 }}>Sin tiempo ciclo: {sinTiempo.join(", ")}</div>
          )}
        </div>
        {ocupado && horario.sugerencia && (
          <ButtonItem naranja onClick={this.usarHoraSugerida}>
            Usar esa hora
          </ButtonItem>
        )}
      </div>
    );
  }

  etiquetaMatriz = (matriz) => (matriz ? `${matriz.clave ? matriz.clave + " - " : ""}${matriz.descripcion || ""}` : "—");

  renderValorSoloLectura = (campo, valor) => {
    if (campo.tipo === "referencia") {
      const SelectorReferencia = SELECTORES_REFERENCIA[campo.entidadReferencia];
      if (SelectorReferencia) {
        return <SelectorReferencia empresaId={this.props.empresaId} headersToken={this.props.headersToken} value={valor} disabled sinBorde bordered={false} />;
      }
    }
    return formatearValorCampoOrden(campo, valor);
  };

  render() {
    const { orden, soloLectura, secciones, partidaSnapshot, presupuesto } = this.state;
    const esNueva = !this.ordenId;
    const tieneConsumo = (orden?.consumos || []).some((c) => c.consumido > 0);
    const camposInsumoPrincipal = flattenCampos(secciones.filter((s) => s.nombre === "Insumo principal"));
    const otrasSecciones = secciones.filter((s) => s.nombre !== "Insumo principal");
    const snapshot = esNueva ? partidaSnapshot : orden?.partidaSnapshot;
    const presupuestoNombre = esNueva ? presupuesto?.nombre : orden?.presupuestoPUId?.nombre;

    return (
      <Spin spinning={this.state.loading}>
        <PageHeader
          onBack={() => this.props.history.goBack()}
          backIcon={<ArrowLeftOutlined />}
          title={esNueva ? "Generar orden de producción" : `Orden ${orden?.folio || ""}`}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={[
            ...(!esNueva
              ? [
                  soloLectura && this.props.permisoEditarOrdenProduccionPU && !tieneConsumo && (
                    <ButtonItem key="editar" botonAncho type="default" cyan icon={<EditOutlined />} onClick={this.habilitarEdicion}>
                      Editar
                    </ButtonItem>
                  ),
                  orden?.yaInicio && orden?.estado === 1 && this.props.permisoEditarOrdenProduccionPU && (
                    <ButtonItem key="ajustarInicio" botonAncho type="default" icon={<ClockCircleOutlined />} onClick={() => this.setState({ modalAjusteInicio: true })}>
                      Ajustar inicio
                    </ButtonItem>
                  ),
                  <ButtonItem
                    key="etapas"
                    botonAncho
                    type="default"
                    icon={<SwapRightOutlined />}
                    onClick={() => this.props.history.push("/panel/verOrdenDeProduccionPU", { id: this.ordenId })}
                  >
                    Ver etapas / mover piezas
                  </ButtonItem>,
                ].filter(Boolean)
              : []),
            <BotonAyudaManuales key="manuales" modulo="ordenesProduccionPU" />,
          ]}
        />

        {this.renderPlaneacion()}

        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          <Form
            ref={this.formRef}
            name="OrdenDeProduccionPU"
            layout
            bottom={
              !soloLectura &&
                (esNueva ? this.props.permisoAgregarOrdenProduccionPU : this.props.permisoEditarOrdenProduccionPU) && (
                  <ButtonItem type="primary" htmlType="submit" loading={this.state.saving} style={{ display: "block", margin: "0 0 0 auto" }}>
                    {esNueva ? "Crear orden" : "Guardar cambios"}
                  </ButtonItem>
                )
            }
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={[16, 16]} style={{ width: "100%", marginBottom: 8 }}>
              <InfoCard
                span={24}
                title="Datos de la orden"
                compact
                sections={[
                  {
                    lg: esNueva ? 8 : 24,
                    items: [
                      { label: "Flujo de producción", value: this.state.flujo?.nombre || "—" },
                      ...(presupuestoNombre || snapshot?.nombre
                        ? [
                            { label: "Presupuesto", value: presupuestoNombre || "—" },
                            { label: "Partida", value: snapshot?.nombre || "—" },
                            { label: "Clave de partida", value: snapshot?.clave || "—" },
                          ]
                        : [{ label: "Origen", value: "Matriz" }]),
                      ...(!esNueva
                        ? [
                            { label: "Cantidad esperada", value: orden?.cantidadEsperada },
                            { label: "Cantidad final", value: orden?.cantidadFinal },
                            { label: "Proyecto Producción", value: orden?.proyectoEjecucionId?.nombre || "—" },
                            { label: "Proyecto General", value: orden?.proyectoOrigenId?.nombre || "—" },
                            { label: "Tipo de lista", value: orden?.tipoLista === "abierta" ? "Abierta" : "Cerrada" },
                            {
                              label: "Inicio real",
                              value: orden?.inicioRealAjustado?.fecha
                                ? `${formatearFechaHora(orden.inicioRealAjustado.fecha)} (ajustado)`
                                : orden?.inicioRealAutomatico
                                ? formatearFechaHora(orden.inicioRealAutomatico)
                                : "Sin iniciar",
                            },
                          ]
                        : []),
                    ],
                  },
                ]}
              />
            </Row>

            <Row gutter={16} style={{ width: "100%" }}>

              {esNueva && (
                <>
                  <Col span={12}>
                    <FormItem name="proyectoEjecucionId" label="Proyecto Producción" required margin tooltip="Dónde se va a consumir el material y producir físicamente la partida.">
                      <SelectProyectosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} placeholder="Proyecto donde se produce" />
                    </FormItem>
                  </Col>
                  <Col span={12}>
                    <FormItem name="proyectoOrigenId" label="Proyecto General" required margin tooltip="De dónde va a traspasarse el material hacia el Proyecto Producción.">
                      <SelectProyectosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} placeholder="Proyecto General" />
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem
                      name="cantidadEsperada"
                      label="Cantidad esperada"
                      required
                      margin
                      tooltip="Lo que se planea producir. El requerido de cada matriz se escala en proporción."
                    >
                      <InputNumberItem style={{ width: "100%" }} min={1} placeholder="Ej. 100" onChange={(cantidadEsperada) => this.setState({ cantidadEsperada }, this.programarValidacionHorario)} />
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem
                      name="tipoLista"
                      label="Tipo de lista"
                      margin
                      initialValue="cerrada"
                      tooltip="Cerrada: el reparto no se puede tocar después de creada la orden (salvo que nada se haya consumido). Abierta: además permite agregar insumos nuevos al recibir material."
                    >
                      <SelectItem>
                        <Option value="cerrada">Cerrada</Option>
                        <Option value="abierta">Abierta</Option>
                      </SelectItem>
                    </FormItem>
                  </Col>
                </>
              )}

              <Col span={8}>
                <FormItem
                  name="fechaInicio"
                  label="Fecha y hora programada"
                  required
                  margin
                  initialValue={moment().startOf("hour").add(1, "hour")}
                  tooltip="Día y hora en que se planea empezar esta orden. No se puede cruzar con otra orden activa del mismo flujo. Si faltan 3 días o menos y no hay inventario suficiente en el Proyecto Producción, la orden se marca en el listado. Solo se puede reprogramar mientras ninguna pieza haya salido de Pendiente."
                >
                  <DatePickerItem
                    style={{ width: "100%" }}
                    allowClear={false}
                    placeholder="Fecha y hora"
                    showTime={{ format: "HH:mm", minuteStep: 5 }}
                    format="DD/MM/YYYY HH:mm"
                    disabled={!esNueva && (soloLectura || orden?.yaInicio)}
                    onChange={this.programarValidacionHorario}
                  />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem name="codigoProduccion" label="Código de producción" margin>
                  <InputItem placeholder="Libre, lo asigna quien crea la orden" disabled={!esNueva && soloLectura} />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem name="insumoRelacionadoId" label="Insumo relacionado" margin tooltip="El insumo que entra a inventario al terminar la orden. Se puede definir después.">
                  <SelectInsumosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} placeholder="Opcional" disabled={!esNueva && soloLectura} />
                </FormItem>
              </Col>
              <Col span={esNueva ? 16 : 8}>
                <FormItem name="descripcion" label="Descripción" margin>
                  <TextAreaItem placeholder="Opcional" disabled={!esNueva && soloLectura} />
                </FormItem>
              </Col>

              <Col span={24}>
                <Divider orientation="left" plain style={{ margin: "8px 0" }}>
                  Matrices a usar
                </Divider>
              </Col>
              <Col span={24}>{this.renderTablaMatrices()}</Col>

              {!esNueva && orden?.tipoLista === "abierta" && (
                <>
                  <Col span={24}>
                    <Divider orientation="left" plain style={{ margin: "16px 0 8px 0" }}>
                      BOM por matriz (lista abierta)
                    </Divider>
                  </Col>
                  <Col span={24}>{this.renderEspecificacionesEditables()}</Col>
                </>
              )}

              {esNueva &&
                camposInsumoPrincipal.map((campo) => renderCampoOrdenProduccionPU(campo, { empresaId: this.props.empresaId, headersToken: this.props.headersToken }))}

              {esNueva &&
                otrasSecciones.map((seccion) => (
                  <React.Fragment key={seccion.nombre}>
                    <Col span={24}>
                      <Divider orientation="left" plain style={{ margin: "16px 0 8px 0" }}>
                        {seccion.nombre}
                      </Divider>
                    </Col>
                    {flattenCampos([seccion]).map((campo) => renderCampoOrdenProduccionPU(campo, { empresaId: this.props.empresaId, headersToken: this.props.headersToken }))}
                  </React.Fragment>
                ))}

              {!esNueva &&
                (soloLectura
                  ? otrasSecciones.map((seccion) => {
                      const camposConValor = (seccion.campos || [])
                        .filter((campo) => campo.estado !== 2)
                        .filter((campo) => orden?.valores?.[campo.key] !== undefined && orden?.valores?.[campo.key] !== "");
                      if (camposConValor.length === 0) return null;
                      return (
                        <React.Fragment key={seccion.nombre}>
                          <Col span={24}>
                            <Divider orientation="left" plain style={{ margin: "16px 0 8px 0" }}>
                              {seccion.nombre}
                            </Divider>
                          </Col>
                          {camposConValor.map((campo) => (
                            <Col span={8} key={campo.key}>
                              <div style={{ fontSize: 11, color: "#999", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 2 }}>
                                {campo.etiqueta}
                              </div>
                              <div style={{ marginBottom: 8 }}>{this.renderValorSoloLectura(campo, orden.valores[campo.key])}</div>
                            </Col>
                          ))}
                        </React.Fragment>
                      );
                    })
                  : otrasSecciones.map((seccion) => (
                      <React.Fragment key={seccion.nombre}>
                        <Col span={24}>
                          <Divider orientation="left" plain style={{ margin: "16px 0 8px 0" }}>
                            {seccion.nombre}
                          </Divider>
                        </Col>
                        {flattenCampos([seccion]).map((campo) => renderCampoOrdenProduccionPU(campo, { empresaId: this.props.empresaId, headersToken: this.props.headersToken }))}
                      </React.Fragment>
                    )))}
            </Row>
          </Form>
        </div>
        <ModalAjustarInicioRealPU
          visible={this.state.modalAjusteInicio}
          ordenId={this.ordenId}
          folio={orden?.folio}
          inicioAjustado={orden?.inicioRealAjustado}
          inicioRealAutomatico={orden?.inicioRealAutomatico}
          onCerrar={() => this.setState({ modalAjusteInicio: false })}
          onGuardado={() => this.setState({ modalAjusteInicio: false }, () => this.cargarOrden())}
        />
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
  permisoAgregarOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b303352b97b73c85edc24")?.activado,
  permisoEditarOrdenProduccionPU:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b3041e58adfd453df65bf")?.activado,
});

export default connect(mapStateToProps)(OrdenDeProduccionPU);
